import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MenuService } from './services/menu.service';
import { GlobalService } from './services/global.service';

import { ModalService } from './shared/modal/modal.service';
import { SupportComponent } from './shared/modal/support/support.component';
import { ChatBotComponent } from './shared/chat-bot/chat-bot.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  name: string;
  menu: Array<any> = [];
  breadcrumbList: Array<any> = [];
  changeText: boolean;
  displayFAB: boolean = false;

  constructor(public dialog: MatDialog, private _router: Router, private menuService: MenuService, private global: GlobalService,) {
    this.changeText = false;
  }


  ngOnInit() {
    // MenuService menu
    this.menu = this.menuService.getMenu();
    this.listenRouting();
    //console.log('go hit from app comp');
  }

  ngDoCheck(){
    if(!this._router.url.includes('login') 
    && !this._router.url.includes('register') 
    && !this._router.url.includes('sign-up') 
    && !this._router.url.includes('forgotPassword') 
    && !this._router.url.includes('resetPassword')
    && !this._router.url.includes('clientReports')){
      //if on a public page, dont display FAB support button
      this.displayFAB = true;
      
      //added here for SSO users to trigger breadcrumbs
      this.menu = this.menuService.getMenu();
      this.listenRouting();
    }else{
      this.displayFAB = false;
    }
    
    //this.global.displayChatBot = this.displayFAB;
  }

  listenRouting() {
    let routerUrl: string, routerList: Array<any>, target: any;
    this._router.events.subscribe((router: any) => {
      //console.log('router', router.urlAfterRedirects);
      routerUrl = router.urlAfterRedirects;
      
      if (routerUrl && typeof routerUrl === 'string' && !routerUrl.includes('resetPassword')) { //this removes the resetpassword link from the routing check
       
        target = this.menu;
        this.global.breadcrumbList.length = 0;
     
        routerList = routerUrl.slice(1).split('/');
        routerList.forEach((router, index) => {
         
          target = target.find(page => page.path.slice(2) === router);
          
           this.global.breadcrumbList.push({
             name: target ? target.name : '',
             path: !target ? '' : (index === 0) ? target.path : `${this.global.breadcrumbList[index-1].path}/${target.path.slice(2)}`
           });
          
          if (index+1 !== routerList.length) {
            target = target.children;
          }
        });
        this.global.breadcrumbList = this.breadcrumbList;
      }
    });
  }

 /*  handleContactUsModal(e) {
    this.modalService.add('contact-support', { ID: Number(localStorage.getItem("userId"))});
  }

  supportModal(): void {
    const dialogRef = this.dialog.open(SupportComponent, {
      //width: '500px',
      //height: '700px',
      data: { }
    });
  }

  chatbotModal(): void {
     var winFeature = 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,' + 'width=450px, height=700px';
    window.open('/#/chatbot', 'window', winFeature);

  } */
}

